import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { Navigate } from 'react-router-dom';

import { PermissionKeys } from '@client/api';
import { DashboardPaths } from '../../../pods/dashboard/dashboard.router';
import { AgreementsPaths } from '../../../pods/agreements/agreements.router';
import { useUserPermission } from '../../../hooks/useUserPermission';

export function AppPageNotFound() {
  const { hasAnyPermission, isLoading } = useUserPermission();

  useEffect(() => {
    toast.error('Page not found');
  }, []);

  if (isLoading) return null;

  const hasDashboardAccess = hasAnyPermission([PermissionKeys.User.DashboardView, PermissionKeys.Tenant.DashboardView]);

  return (
    <Navigate to={hasDashboardAccess ? DashboardPaths.Dashboard : AgreementsPaths.AgreementList} replace />
  );
}
